module.exports = __webpack_public_path__ + "static/kitchen_night_mobile-78ed89ccb574d8c77864f915ddf3745d.jpg";